export default "__VITE_ASSET__BEoa5uyD__"